
import React, { useState } from "react";
import previewStyles from "./WhatsappPreview.module.css";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WhatsappMobileBlank from "../../../src/Assets/Images/whatsapp_mobile_blank.png";
import MessagePreviewShownHere from "../../../src/Assets/Images/messagePreviewShownHere.png";
// import previewStyles from "../../Screens/MarketingAutomation/NewBroadCastFlow.module.css"

type Props = {
    previewContent: string;
    expanded?: boolean;
    onChange?: () => void;
};


const WhatsappPreview: React.FC<Props> = ({ previewContent, expanded, onChange }) => {
    return (
        <div className={previewStyles.whatsappPreviewWrapper}>
            <img
                className={previewStyles.whatsappPreviewBlankImg}
                src={WhatsappMobileBlank}
                alt="whatsapp-preview-blank"
            />
            {previewContent ? (
                <div className={previewStyles.textOverlay}>
                    <p
                        dangerouslySetInnerHTML={{
                            __html:
                                    previewContent.replace(/\n/g, "<br/>")
                                    .replace(/ {2}/g, "&nbsp;&nbsp;")
                        }}
                    />
                </div>
            ) : (
                <div className={previewStyles.messagePreviewContainer}>
                    <img
                        src={MessagePreviewShownHere}
                        alt="message-preview-shown-here"
                    />
                </div>
            )}
        </div>
    );
};

export default WhatsappPreview;